module.exports = __webpack_public_path__ + "img/japanese-food-with-chopsticks.d878ad79.svg";